import { PoolNotification } from '@/types/notification';
import { PaginationMeta } from '@/types/pagination';
import { apiClient } from './apiClient';

export type NotificationListResponse = {
  notifications: PoolNotification[];
  pagination: PaginationMeta;
};

type GetNotificationsParams = {
  page?: number;
  page_size?: number;
  is_read?: boolean;
  pool_id?: number;
};

export const notificationService = {
  async getNotifications(params: GetNotificationsParams = {}) {
    const searchParams = new URLSearchParams();
    if (params.page != null) searchParams.set('page', String(params.page));
    if (params.page_size != null) searchParams.set('page_size', String(params.page_size));
    if (params.is_read != null) searchParams.set('is_read', String(params.is_read));
    if (params.pool_id != null) searchParams.set('pool_id', String(params.pool_id));
    const qs = searchParams.toString();
    return apiClient<NotificationListResponse>(`/api/notifications${qs ? `?${qs}` : ''}`);
  },

  async getNotificationsByPoolId(poolId: number, params: { page?: number; page_size?: number } = {}) {
    return this.getNotifications({ pool_id: poolId, ...params });
  },

  /**
   * Mark pool notification as read
   */
  async markPoolNotificationAsRead(poolId: number) {
    return apiClient<void>(`/api/pools/${poolId}/notifications/mark-all-as-read`, {
      method: 'PUT',
    });
  },

  /**
   * Mark all notifications as read
   */
  async markAllRead() {
    return apiClient('/api/notifications/mark-all-as-read', {
      method: 'PUT',
    });
  },
};
